import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  SearchMovie(payload) {
    return Api().get(`/api/admin/searchmovies?s=${payload.search}`);
  },
  GetsearchMovieDetails(payload) {
    return Api().post(`/api/admin/getsearchmoviedetails`, payload);
  },
  AddMovie(payload) {
    // return Api().post(`/movie/add-movie`, payload)
    return Api().post(`/api/admin/insertmovie`, payload);
  },
  GetMovies(payload) {
    // return Api().get(`/movie/movielist?limit=${payload.limit}&currentPage=${payload.currentPage}`)
    return Api().get(
      `/api/admin/getmovieslist?searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}`
    );
  },
  GetMovies2(payload) {
    // return Api().get(`/movie/movielist?limit=${payload.limit}&currentPage=${payload.currentPage}`)
    if (payload.status) {
      return Api().get(
        `/api/admin/getmovies?searchKey=${payload.searchKey}&searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}&status=${payload.status}&region_id=${payload.region_id}`
      );
    } else {
      return Api().get(
        `/api/admin/getmovies?searchKey=${payload.searchKey}&searchValue=${payload.searchValue}&limit=${payload.limit}&currentPage=${payload.currentPage}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    }
  },
  GetEditMoviesDetails(payload) {
    // return Api().get(`/movie/viewmovie/${payload.movie_details_id}`)
    return Api().get(`/api/admin/getviewmoviedetails/${payload.movie_id}`);
  },
  updateMovie(payload) {
    // return Api().put(`/movie/updatemovie/${payload.movie_details_id}`, payload)
    return Api().put(
      `/api/admin/updatemoviedetails/${payload.movie_id}`,
      payload
    );
  },
  GetActiveMoviesWithFormat(payload) {
    const query = createQueryString(payload);
    return Api().get(`/api/admin/activemovies/${query}`);
  },
  GetActiveDetailsMoviesWithFormatByMasterMovieID(payload) {
    return Api().get(`/api/admin/activemoviedetails/${payload.movie_id}`);
  },
  GetActiveMasterMovies(payload) {
    if (payload && payload.hasOwnProperty("movie_is_active")) {
      return Api().get(`/api/admin/tablelist/ms_movies?movie_is_active=Y`);
    } else {
      return Api().get(`/api/admin/tablelist/ms_movies`);
    }
  },
  GetMovieContentLanguages() {
    return Api().get(`/api/admin/getmoviecontentlanguage`);
  },
  UpdateTSMID(payload) {
    return Api().post(`/api/admin/tms`, payload);
  },
  GetDeeplTranslations(payload) {
    return Api().post(`/api/admin/deepl-transations`, payload);
  },
  GetExternalMovies(payload) {
    return Api().get(
      `/api/admin/external_movies?searchValue=${payload.search}`
    );
  },
  GetSingleExternalMovie(payload) {
    return Api().get(`/api/admin/external_movies/${payload.suisa_id}`);
  },
  FetchCinePoolMovie(payload) {
    return Api().get(`/api/admin/fetch_external_movies/${payload.suisa_id}`);
  },
  GetDefaultScreeingTypes() {
    return Api().get(`/api/admin/default_screening_type`);
  },
  AddMovieRateCard(payload) {
    return Api().post(`/api/admin/movie_rate_card`, payload);
  },
  GetMovieRateCard(payload) {
    return Api().get(`/api/admin/movie_rate_card/${payload.md_id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/MovieService.js